import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class AdditionExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return left + right;
    }
}
//# sourceMappingURL=AdditionExpression.js.map